var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgInfo = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_103_17)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.99989 1.81706C10.661 1.81543 12.2713 2.38982 13.5564 3.44236C14.8415 4.49491 15.7219 5.96048 16.0476 7.58938C16.3733 9.21827 16.1241 10.9097 15.3425 12.3754C14.5609 13.8412 13.2952 14.9906 11.7611 15.6278C10.2271 16.265 8.51956 16.3506 6.92948 15.8699C5.3394 15.3893 3.96517 14.3722 3.04093 12.9919C2.11669 11.6117 1.69964 9.95365 1.86082 8.30036C2.022 6.64707 2.75146 5.10081 3.92489 3.92506C4.59132 3.25732 5.38326 2.728 6.25511 2.36759C7.12696 2.00718 8.06148 1.8228 9.00489 1.82506L8.99989 1.81706ZM9.00489 0.00805664C7.22485 0.00805664 5.4848 0.535898 4.00476 1.52483C2.52471 2.51376 1.37116 3.91937 0.689971 5.56391C0.00878215 7.20844 -0.169448 9.01804 0.177819 10.7639C0.525086 12.5097 1.38225 14.1133 2.64093 15.372C3.8996 16.6307 5.50325 17.4879 7.24907 17.8351C8.9949 18.1824 10.8045 18.0042 12.449 17.323C14.0936 16.6418 15.4992 15.4882 16.4881 14.0082C17.477 12.5281 18.0049 10.7881 18.0049 9.00806C18.0049 6.62111 17.0567 4.33192 15.3688 2.6441C13.681 0.956269 11.3918 0.00805664 9.00489 0.00805664V0.00805664Z",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.91289 13.5169H8.08789V8.08789H9.91189L9.91289 13.5169ZM9.91289 6.30789H8.08789V4.48389H9.91189L9.91289 6.30789Z",
    fill: "#757575"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_103_17"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInfo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "3b72714f69dea2fb9d89f30bf14c0140.svg";